// extracted by mini-css-extract-plugin
module.exports = {"ldsdefault":"Submitbutton_ldsdefault__1Os6v"};